import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import Breadcrumb from "../Breadcrumb";
import { Modal } from "react-bootstrap";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const CompletedUnitsListLayer = () => {
    const [completedUnits, setCompletedUnits] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [token, setToken] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedUnitId, setSelectedUnitId] = useState(""); // Store selected unit ID for deletion
    const [showDeleteModal, setShowDeleteModal] = useState(false); // For delete confirmation modal
    const [itemToDelete, setItemToDelete] = useState(null); // For the unit to delete
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [roleName, setRoleName] = useState("");

    const navigate = useNavigate();
    const { batchId } = useParams(); // Get batchId from URL parameters

    useEffect(() => {
        const storedToken = localStorage?.getItem("token");
        const user = localStorage?.getItem("user");
        const parsedUser = JSON.parse(user);
        const role = parsedUser?.rolename;
        setRoleName(role);

        setToken(storedToken);
    }, []);

    useEffect(() => {
        if (token && batchId) {
            fetchCompletedUnits();
        }
    }, [
        token,
        batchId,
        currentPage,
        itemsPerPage,
        searchTerm,
    ]);

    const fetchCompletedUnits = async () => {
        setLoading(true);
        setError(null);
        try {
            if (!token) {
                // console.log("Access required");
                return;
            }

            const url = `${process.env.REACT_APP_INSTITUTION_BASEURL}/completed-courses/${batchId}?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}`;
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            });

            // console.log("Completed Units Response:", response);
            const startSerial = (currentPage - 1) * itemsPerPage + 1; // Calculate serial for current page
            const unitsWithSerial = response.data.data.map((item, index) => ({
                ...item,
                serial: startSerial + index,
            }));

            setCompletedUnits(unitsWithSerial);
            setTotalItems(response.data.pagination.totalItems);
            setTotalPages(response.data.pagination.totalPages);
        } catch (error) {
            console.error("Failed to fetch completed units:", error);
            setError("Failed to fetch completed units.");
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page on search change
    };

    const handleDeleteClick = (item) => {
        setItemToDelete(item);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setItemToDelete(null);
    };

    const handleConfirmDelete = async () => {
        try {
            await handleDeleteUnit(itemToDelete);
            handleCloseDeleteModal();
        } catch (error) {
            console.error("Delete failed:", error);
        }
    };

    const handleDeleteUnit = async (unit) => {
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_INSTITUTION_BASEURL}/delete-completed-unit/${unit._id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.status === 200) {
                setSnackbarMessage("Deleted successfully!");
                setSnackbarSeverity("success");
                setOpenSnackbar(true);
                fetchCompletedUnits(); // Refresh list after deletion
            }
        } catch (err) {
            console.error(err);
            setSnackbarMessage("Failed to delete. Please try again.");
            setSnackbarSeverity("error");
            setOpenSnackbar(true);
        }
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    const handleVerifyClick = async (unit) => {
        // console.log("unitiddddddd",unit)
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_INSTITUTION_BASEURL}/verify-completed-unit/${unit.unit_id}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
    
            if (response.status === 200) {
                setSnackbarMessage("Unit verified successfully!");
                setSnackbarSeverity("success");
                setOpenSnackbar(true);
                fetchCompletedUnits(); // Refresh the list after verification
            }
        } catch (err) {
            console.error(err);
            setSnackbarMessage("Failed to verify unit. Please try again.");
            setSnackbarSeverity("error");
            setOpenSnackbar(true);
        }
    };
    

    return (
        <>
            <div className="d-flex justify-content-between">
                {/* <h5>Completed Units</h5> */}
                {/* <Breadcrumb title="Completed Units" /> */}
            </div>
            <div className="card h-100 p-0 radius-12">
                {loading && (
                    <div className="loader-container" style={styles.loaderContainer}>
                        <CircularProgress />
                    </div>
                )}
                <div className="card-header border-bottom bg-base py-16 px-24">
                    <div className="row g-3">
                        {/* Search Field */}
                        <div className="col-12 col-sm-6 col-md-6 col-xl-3">
                            <form
                                className="search px-10"
                                style={{
                                    border: "1px solid #6b7280",
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: "10px",
                                }}
                                onSubmit={(e) => e.preventDefault()}
                            >
                                <Icon
                                    icon="ion:search-outline"
                                    className="icon"
                                    style={{ marginRight: "10px" }}
                                />
                                <input
                                    type="text"
                                    className="bg-base h-40-px"
                                    name="search"
                                    onChange={handleSearchChange}
                                    value={searchTerm}
                                    placeholder="Search"
                                />
                            </form>
                        </div>
                        {/* Add New Button (Conditional render based on role) */}
                        <div
                            className="col-12 col-sm-6 col-md-6 col-xl-2"
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                order: "2",
                                marginLeft: "auto",
                            }}
                        >
                            {roleName === "Admin" && (
                                <Link
                                    to="/add-completed-unit"
                                    className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                                >
                                    <Icon icon="ic:baseline-plus" />
                                    Add New
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
                <div className="card-body p-24">
                    <div className="table-responsive scroll-sm">
                        <table className="table bordered-table sm-table mb-0">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        <div className="d-flex align-items-center gap-10">S.L</div>
                                    </th>
                                    <th scope="col">Student</th>
                                    <th scope="col">Course</th>
                                    <th scope="col">Chapter</th>
                                    <th scope="col">Unit</th>
                                    {/* <th scope="col">Completed</th> */}
                                    <th scope="col">Completion Status</th>
                                    {/* <th scope="col" className="text-center">
                                        Action
                                    </th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {completedUnits.length > 0 ? (
                                    completedUnits.map((unit, index) => (
                                        <tr key={unit._id}>
                                            <td>{unit.serial}</td>
                                            <td>{unit.studentData.user_name}</td>
                                            <td>{unit.courseData.coursename}</td>
                                            <td>{unit.chapterData.chaptername}</td>
                                            <td>{unit.unitData.unitname}</td>
                                            <td>{unit.student_status}</td>
                                            {/* <td className="text-center">
                                                <div className="d-flex align-items-center gap-10 justify-content-center">
                                                    {roleName === "Tutor" && (
                                                       <>
                                                    
                                                       <div className="d-flex align-items-center">
                                                            <input
                                                                type="checkbox"
                                                                id={`verify-${unit.id}`}
                                                                className="form-check-input me-2"
                                                                checked={unit.verification_status === "verified"}
                                                                onChange={() => handleVerifyClick(unit)}
                                                                style={{
                                                                    width: '40px',
                                                                    height: '40px',
                                                                    cursor: 'pointer',
                                                                    backgroundColor: unit.verification_status === "verified" ? '#0dcaf0' : '#fff',
                                                                    borderColor: '#0dcaf0',
                                                                    borderRadius: '30px',
                                                                }}
                                                            />
                                                            <label 
                                                                htmlFor={`verify-${unit.id}`}
                                                                className="visually-hidden"
                                                            >
                                                                Verify unit
                                                            </label>
                                                        </div>
                                                   </>
                                                    )}
                                                </div>
                                            </td> */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            No completed units found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                        <span>
                            Showing{" "}
                            {completedUnits.length === 0
                                ? "0"
                                : `${(currentPage - 1) * itemsPerPage + 1}`}{" "}
                            to{" "}
                            {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}{" "}
                            entries
                        </span>

                        <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                            {/* Previous Button */}
                            <li className="page-item">
                                <Link
                                    className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                    to="#"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    style={{
                                        pointerEvents: currentPage === 1 ? "none" : "auto",
                                        opacity: currentPage === 1 ? 0.5 : 1,
                                    }}
                                >
                                    <Icon icon="ep:d-arrow-left" />
                                </Link>
                            </li>

                            {/* Current Page Number */}
                            <li className="page-item">
                                <span className="page-link bg-primary-600 text-white fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md">
                                    {currentPage}
                                </span>
                            </li>

                            {/* Next Button */}
                            <li className="page-item">
                                <Link
                                    className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                    to="#"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    style={{
                                        pointerEvents: currentPage === totalPages ? "none" : "auto",
                                        opacity: currentPage === totalPages ? 0.5 : 1,
                                    }}
                                >
                                    <Icon icon="ep:d-arrow-right" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Delete Modal */}
            <Modal
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Unit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this completed unit?
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-secondary"
                        onClick={handleCloseDeleteModal}
                    >
                        Close
                    </button>
                    <button
                        className="btn btn-danger"
                        onClick={handleConfirmDelete}
                    >
                        Delete
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Snackbar for success/error messages */}
            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </>
    );
};

const styles = {
    loaderContainer: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 999,
    },
};

export default CompletedUnitsListLayer;
